import React, { lazy, Suspense, useEffect, useState } from "react";
import "./login-modal.scss";
import DefaultModal from "../DefaultModal";
import { useAppSelector } from "../../../store/index.ts";

const RecoveryPas = lazy(() => import("./recovery-pas/RecoveryPas"));
const LoginImg = lazy(() => import("./LoginImg"));
const LoginFields = lazy(() => import("./LoginFields"));

export default function LoginModal({ isOpen, closeModal, data: dataLogin, hideCross }) {
  const lockLoginClose = useAppSelector((state) => state.site.lock.loginClose);
  const [forgotPas, setForgotPas] = useState(false);
  const classModal = forgotPas ? "recovery-pas" : "login-modal";

  useEffect(() => {
    setForgotPas(false);
  }, [isOpen]);

  return (
    <DefaultModal
      classModal={classModal}
      isOpen={isOpen}
      closeModal={!lockLoginClose && closeModal}
      hideClose={hideCross || lockLoginClose}>
      {forgotPas ? (
        <Suspense>
          <RecoveryPas setForgotPas={setForgotPas} />
        </Suspense>
      ) : (
        <Suspense>
          <LoginImg />
          <LoginFields setForgotPas={setForgotPas} dataLogin={dataLogin} closeModal={closeModal} />
        </Suspense>
      )}
    </DefaultModal>
  );
}
